// @ts-strict-ignore
import { Env } from 'src/app/core/config/config.model';
import { URLS } from 'src/app/core/config/url.config';
import { FinanceCalculatorEnvironment } from 'src/app/shared/financing/finance-calculator/finance-calculator-environment.enum';
import { MOTORIZATION_GUARD_DATA_TIMEOUT, OcapiApiApiKey, OneMirrorAccessToken } from 'src/app/utils/global-constants';
import { DoorwayElement, type Settings } from 'src/configs/settings/settings.interface';

/**
 * Settings
 * - for 'unknown' environments (host lookup)
 * - for all environments if not specified for specific environment
 */
export const settings: Settings = {
  doorwayConfiguration: {
    disabled: [DoorwayElement.SalesLevelType, DoorwayElement.ConfigurationDate]
  },
  apis: {
    backend: {
      baseUrl: URLS.apis.owcc.prodCached,
      mailEndpoint: 'mail',
      onlineCodesEndpoint: 'onlinecodes',
      timeout: {
        motorization: MOTORIZATION_GUARD_DATA_TIMEOUT
      },
      retryCount: 0,
      formattingTag: ''
    },
    carl: {
      baseUrl: URLS.apis.carl.prodCached,
      label: ''
    },
    deeplinks: {
      baseUrl: URLS.apis.deeplinks.test
    },
    ocapi: {
      baseUrl: URLS.apis.ocapi.test,
      apiKey: OcapiApiApiKey.Test
    },
    omds: {
      accessToken: OneMirrorAccessToken.Prod,
      baseUrl: URLS.apis.omds[Env.Prod],
      relayService: URLS.apis.omdsRelayService[Env.Prod]
    }
  },
  abTesting: {
    activeInStandaloneMode: false
  },
  financialCalculatorEnvironment: FinanceCalculatorEnvironment.Production
};
